export default __webpack_public_path__ + "static/media/statusIconPending.457ab065.svg";